import { Component, Input, OnInit } from '@angular/core';
import { AuthService } from 'src/app/core/auth/auth.service';
import { TowerGroupDto } from 'src/app/api/models';
import { HelperService } from 'src/shared/services/helpers/helper.service';
import { IconComponent } from "../elements/icon/icon.component";
import { NgIf } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'vl-context-help',
  templateUrl: './context-help.component.html',
  styleUrls: ['./context-help.component.scss'],
  imports: [IconComponent, NgIf, TranslatePipe],
})
export class ContextHelpComponent implements OnInit {
  @Input() key: string;
  @Input() showContactUs: boolean;
  @Input() group: TowerGroupDto;
  @Input() displayText: string;
  language: string;
  public isPublicView: boolean = true;

  constructor(
    private helperService: HelperService,
    private authService: AuthService
  ) {
    this.authService.$userAuth.subscribe(b => {
			this.isPublicView = !b;
		});
  }

  async ngOnInit() {
  }

  async checkRoute() {
    this.helperService.checkRoute(this.key, this.showContactUs, this.group);
  }
}
